export const FACEBOOK_LANDING_PATH = 'brand-landing/facebook/index';
